var noticeUtils = {}
noticeUtils.succ = function (msg, fn) {
    if (fn == null || fn == undefined) {
        $app.$message({
            message: msg,
            type: 'success'
        });
        return;
    }
    if(fn===true)
    {
        fn=function(){}
    }
    var __self = $app;
    var args = arguments;
    $app.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        showCancelButton: false,
        type: 'success',
    }).then(() => {
        fn.apply(__self, args);
    }).catch(() => {
        $app.$message({
            type: 'info',
            message: '操作异常'
        });
    });
}

noticeUtils.fail = function (msg, fn) {
    var __self = $app;
    var args = arguments;
    $app.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        showCancelButton: false,
        lockScroll: true,
        type: 'error'
    }).then(() => {
        if (fn != null && fn != undefined)
            fn.apply(__self, args);
    });
};

noticeUtils.tips = function (msg, timer) {
    return $app.$message(msg, {
        duration: timer
    });
};
export default noticeUtils;



// WEBPACK FOOTER //
// ./src/utils/noticeUtils.js